import { createAction } from '@ngrx/store';

export const listenToUsersChanges = createAction(
	'[Feature][App] Start Listening To Users Changes',
);
